export const namespaced = true;

import StudentService from '@/services/StudentService.js';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';

export const state = {
  students: [],
};

export const mutations = {
  SET_STUDENTS(state, students) {
    state.students = students;
  },
  CLEAR_STUDENTS(state) {
    state.students = [];
  },
};

export const actions = {
  finishEditingTrialStudent({ commit }, trialStudent) {
    let formattedStudent = cloneDeep(trialStudent);
    if (formattedStudent.corporation) {
      formattedStudent.corporationId = formattedStudent.corporation.id;
      formattedStudent = omit(formattedStudent, ['corporation']);
    }
    if (formattedStudent.brand) {
      formattedStudent.brandId = formattedStudent.brand.id;
      formattedStudent = omit(formattedStudent, ['brand']);
    }
    if (formattedStudent.school) {
      formattedStudent.schoolId = formattedStudent.school.id;
      formattedStudent = omit(formattedStudent, ['school']);
    }
    if (formattedStudent.course) {
      formattedStudent.courseId = formattedStudent.course.id;
      formattedStudent = omit(formattedStudent, ['course']);
    }
    if (formattedStudent.tamaiClass) {
      formattedStudent.tamaiClassId = formattedStudent.tamaiClass.id;
      formattedStudent = omit(formattedStudent, ['tamaiClass']);
    }
    if (formattedStudent.trialTeachingMaterialCode != 'trialCode') {
      formattedStudent = omit(formattedStudent, ['trialCourseCode']);
    }
    return StudentService.registerTrial(formattedStudent).then((response) => {
      commit('SET_STUDENTS', response.data);
    });
  },
};

export const getters = {
  totalStudents: (state) => {
    return state.students.length;
  },
};
